// src/utils/eventBus.js
import Vue from "vue";
export const EventBus = new Vue();
